export class ClientConfigResponse {
    status: string;
    captcha: Captcha;
    captchaRequired: boolean;
    programName: string;
    isProgramSSO: string;
    programMake: string;
    userSSOSuffix: string;
    programId: string;
    clientInfo: ClientInfo;
    clientInfo_i18n: ClientInfoI18n[];
    applicationId: string;
    loginBox: LoginBox;
    multilingual: string;
    leftJustify: boolean;
    languageCode: string;
    css: CSS;
    images: Images;
    imageIds: ImageId[];

    constructor() {
        this.css = new CSS();
        this.images = new Images();
        this.captcha = new Captcha();
        this.captchaRequired = false;
        this.imageIds = [];
    }
}

export class CSS {
    logoBkgrdColor: string;
    primaryColor: string;
    secondaryColor: string;
    brandBarColor: string;
    fontColor: string;
    buttonColor: string;
    emulateBanner: EmulateBanner;

    constructor() {
        this.emulateBanner = new EmulateBanner();
    }
}

export class EmulateBanner {
    bkgrdColor: string;
    fontColor: string;

    constructor() {
        this.bkgrdColor = '#FF7A7A';
        this.fontColor = '#FFFFFF';
    }
}

export class LoginBox {
    boldTitle: boolean;
    leftJustify: boolean;
}

export class ClientInfo {
    title: string;
    text: string;
}

export class ClientInfoI18n extends ClientInfo {
    languageCode: string;
}

export class Images {
    loginPageBackground: string;
    logo: string;
    logo_fr_CA: string;
    logoMiddle: string;
    logoRight: string;
    navbarLogo: string;
    navbarLogo_fr_CA: string;
    homePageLinks: string;
}

export class Captcha {
    data: string;
    text: string;
    required: boolean;
    encText: string;
}

export class ImageId {
    imageName: string;
    imageId: string;
    image: any;
}
